import httpWrap from '../../../../procedures/http-wrap';
import showPdf from '../../../../procedures/show-pdf';
import action from '../../../abstract/action.js';
import { signStatusOptions } from '../index';

const handle = async (
  {
    $vs,
    item,
    model: {
      api: {
        showContent,
      },
    },
  },
) => {
  const { content } = await httpWrap({ $vs, action: showContent })(item);
  showPdf(content);
};

export default action({
  label: 'Podgląd',
  icon: 'SearchIcon',
  main: ({ item }) => item.sign_status === signStatusOptions.bothSign.value,
  handle,
});
